import { FC } from 'react';

export const RightPanels: FC = () => {
  return (
    <div id="right-panels" className="resizablePanelContainer right">
      <div id="property_panel" className="resizablePanel property-panel-widget"></div>
    </div>
  );
};
